import React from 'react';
import Row from 'components/row';
import Col from 'components/col';

module.exports = (props) => {
  var marker = props.marker || '*';
  return (
    <Row>
      <Col size="sm-12" className="aviso-quantidade">
        ({marker}) ATENÇÃO! Somente participar da cotação se possuir estoque suficiente para nos atender.
      </Col>
    </Row>
  )
};


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/aviso-quantidade.js
 **/